export default "__VITE_ASSET__NYMdbdEY__"